import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@/components/ui/card'
import {
  identityFieldKey,
  identityRequiresReview,
} from '@/features/entity-resolution/identityAssessment'
import type { IdentityAssessment } from '@/services/api/entity-resolution-groups'
import { cn } from '@/utils/cn'

export function IdentityAssessmentNotice({
  assessment,
  showAll = false,
}: {
  assessment: IdentityAssessment | undefined
  showAll?: boolean
}) {
  const { t } = useTranslation()
  if (!assessment || (!showAll && !identityRequiresReview(assessment))) return null
  return (
    <Card className={cn('gap-0 py-3', assessment.status === 'conflict' && 'border-destructive/40')}>
      <CardContent className="space-y-1 px-3 text-xs">
        <p className="font-medium">{t(`resolutionIdentity.status.${assessment.status}`)}</p>
        <p>{t(`resolutionIdentity.description.${assessment.status}`)}</p>
        <AssessmentFields kind="conflicts" fields={assessment.conflicts} />
        <AssessmentFields kind="review" fields={assessment.reviewFields} />
        <AssessmentFields kind="matched" fields={assessment.matchedFields} />
      </CardContent>
    </Card>
  )
}

function AssessmentFields({ kind, fields }: { kind: string; fields: string[] }) {
  const { t } = useTranslation()
  if (!fields.length) return null
  return (
    <p>
      {t(`resolutionIdentity.fieldGroups.${kind}`)}:{' '}
      {fields.map(field => t(identityFieldKey(field))).join(', ')}
    </p>
  )
}
